import { createAction, props } from '@ngrx/store';
import { CurrentState, MainMenuState } from '../states/perm.state';

export const PERM_SET_MENU = '[PERM][SET]::[Menu]';
export const PERM_RESET_MENU = '[PERM][RESET]::[Menu]';
export const PERM_SET_CURRENT = '[PERM][SET]::[CURRENT]';
export const PERM_RESET_CURRENT = '[PERM][RESET]::[CURRENT]';

export const SetMenu = createAction(
  PERM_SET_MENU,
  props<{ menus: MainMenuState[] }>()
);
export const SetCurrent = createAction(
  PERM_SET_CURRENT,
  props<{ perm: CurrentState | undefined }>()
);
export const ResetMenu = createAction(PERM_RESET_MENU);
export const ResetCurrent = createAction(PERM_RESET_CURRENT);
